module.exports = __webpack_public_path__ + "static/img/product_images_big15_h5_zh.c3acfb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big15_h5_zh.png
// module id = VXM9
// module chunks = 34